import { useMediaQuery } from 'react-responsive';

/**
 * Use the useHeaderHeight hook instead or the --navigation-height css var
 * @deprecated
 */
export function useNavigationHeight() {
  const isMD = useMediaQuery({
    maxWidth: 992
  });
  const isSM = useMediaQuery({
    maxWidth: 768
  });
  if (isMD && !isSM) {
    return 60;
  }
  return 85;
}